import merge from "lodash/merge";
const DEFAULT_TEXT_COLOR = '#222';
// TODO: refactor approach if charts theme no longer needs to be overridden
export function generateChartsTheme(muiTheme, echartsTheme, /**
   * The id of the container that will have the chart tooltip appended to it.
   * By default, chart tooltip uses the body of the top-level document object.
   */ tooltipPortalContainerId) {
    const primaryTextColor = muiTheme.palette.text?.primary ?? DEFAULT_TEXT_COLOR;
    const muiConvertedTheme = {
        title: {
            show: false
        },
        textStyle: {
            color: primaryTextColor,
            fontFamily: muiTheme.typography.fontFamily,
            fontSize: 12
        },
        grid: {
            top: 5,
            right: 20,
            bottom: 0,
            left: 20,
            containLabel: true
        },
        // https://www.figma.com/file/bRoUgi8hJLBdNphmMnFkr7/%F0%9F%9A%A7-Chrono-UI?type=design&node-id=3829-72816&mode=design&t=KL7ED1NmnjAyfKlv-0
        color: [
            '#68C7FF',
            '#005BCE',
            '#FF9292',
            '#9C597E',
            '#02B4C1',
            '#816AB5',
            '#98003C'
        ],
        categoryAxis: {
            show: true,
            axisLabel: {
                show: true,
                color: primaryTextColor,
                margin: 10
            },
            axisTick: {
                show: false,
                length: 6,
                lineStyle: {
                    color: muiTheme.palette.grey[600]
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: muiTheme.palette.grey[600]
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    width: 0.5,
                    color: muiTheme.palette.grey[300],
                    opacity: 0.4
                }
            },
            splitArea: {
                show: false,
                areaStyle: {
                    color: [
                        muiTheme.palette.grey[300]
                    ]
                }
            }
        },
        timeAxis: {
            show: true,
            axisLabel: {
                show: true,
                color: primaryTextColor,
                margin: 10
            },
            axisTick: {
                show: false,
                length: 6,
                lineStyle: {
                    color: muiTheme.palette.grey[600]
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: muiTheme.palette.grey[600]
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    width: 0.5,
                    color: muiTheme.palette.grey[300],
                    opacity: 0.4
                }
            },
            splitArea: {
                show: false,
                areaStyle: {
                    color: [
                        muiTheme.palette.grey[300]
                    ]
                }
            }
        },
        valueAxis: {
            show: true,
            axisLabel: {
                color: primaryTextColor,
                margin: 10
            },
            axisLine: {
                show: false
            },
            splitLine: {
                show: true,
                lineStyle: {
                    width: 0.5,
                    color: muiTheme.palette.grey[300],
                    opacity: 0.6
                }
            }
        },
        legend: {
            orient: 'horizontal',
            textStyle: {
                color: primaryTextColor
            },
            pageTextStyle: {
                color: muiTheme.palette.grey[600]
            },
            pageIconColor: muiTheme?.palette?.action?.active,
            pageIconInactiveColor: muiTheme?.palette?.action?.disabled
        },
        toolbox: {
            show: true,
            top: 10,
            right: 10,
            iconStyle: {
                borderColor: primaryTextColor
            }
        },
        tooltip: {
            backgroundColor: muiTheme.palette.designSystem?.grey[800],
            borderColor: muiTheme.palette.designSystem?.grey[800],
            textStyle: {
                color: '#fff',
                fontSize: 11
            }
        },
        axisPointer: {
            lineStyle: {
                color: muiTheme.palette.grey[500]
            }
        },
        markLine: {
            symbol: 'none',
            symbolSize: 0,
            itemStyle: {
                color: muiTheme.palette.grey[500]
            },
            lineStyle: {
                type: 'dashed',
                width: 1
            }
        },
        line: {
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 4,
            smooth: false,
            lineStyle: {
                width: 1
            },
            emphasis: {
                lineStyle: {
                    width: 1.5
                }
            }
        },
        bar: {
            barMaxWidth: 150,
            itemStyle: {
                borderWidth: 0,
                borderRadius: 0,
                borderColor: muiTheme.palette.grey[300]
            },
            label: {
                show: false,
                color: primaryTextColor
            }
        },
        gauge: {
            detail: {
                fontSize: 18,
                fontWeight: 600,
                valueAnimation: false
            },
            splitLine: {
                distance: 0,
                length: 4,
                lineStyle: {
                    width: 1
                }
            },
            splitNumber: 12
        }
    };
    return {
        theme: muiTheme,
        tooltipPortalContainerId,
        echartsTheme: merge(muiConvertedTheme, echartsTheme),
        noDataOption: {
            title: {
                show: true,
                textStyle: {
                    color: primaryTextColor,
                    fontSize: 16,
                    fontWeight: 400
                },
                text: 'No data',
                left: 'center',
                top: 'center'
            },
            xAxis: {
                show: false
            },
            yAxis: {
                show: false
            }
        },
        sparkline: {
            width: 2,
            color: '#1976d2'
        },
        container: {
            padding: {
                x: parseInt(muiTheme.spacing(1), 10),
                y: parseInt(muiTheme.spacing(1), 10)
            }
        },
        thresholds: {
            defaultColor: muiTheme.palette.primary.main,
            palette: [
                '#DA7B07',
                muiTheme.palette.error.main
            ],
            labelBackgroundColor: 'rgba(255, 255, 255, 0.8)',
            labelColor: muiTheme.palette.grey[400]
        },
        yAxis: {
            label: {
                chartPadding: parseInt(muiTheme.spacing(1), 10)
            }
        },
        stripedDecal: {
            dashArrayX: [
                1,
                0
            ],
            dashArrayY: [
                4,
                3
            ],
            rotation: -Math.PI / 4,
            color: 'white'
        }
    };
}

//# sourceMappingURL=theme-gen.js.map